<template>
  <v-alert v-if="issue" type="error" dense text icon="mdi-account-hard-hat-outline" class="text-body-2">
    <div class="font-weight-bold">{{ $t('onboarding.commissioning.field-issue.title') }}</div>
    <div>{{ fieldIssueLabel(issue) }}</div>
    <div class="text-caption">
      {{ $t('onboarding.commissioning.field-issue.by', { by: issue.by || '-', date: $options.filters.formatDate(issue.at) }) }}
      · {{ $t('onboarding.commissioning.field-issue.next') }}
    </div>
  </v-alert>
</template>

<script>
import CommissioningMixin from '../CommissioningMixin'

/**
 * Le problème que le technicien a signalé sur place (personne absente, site non conforme…) : la pose est revenue « à
 * planifier ». Il se voit en rouge tant qu'une nouvelle date ou un technicien ne l'a pas résolu.
 */
export default {
  name: 'OrderFieldIssue',

  mixins: [CommissioningMixin],

  props: {
    order: { type: Object, required: true },
  },

  computed: {
    issue() {
      const issue = this.order.fieldIssue
      return issue && !issue.resolvedAt ? issue : null
    },
  },
}
</script>
